var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunnelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "25.05 19.33 25.89 33.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_12",
    "data-name": "Artboard \\u2013 12",
    clipPath: "url(#clip-Artboard_12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(-223.129 -195.486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(248.684 229.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_89",
    "data-name": "Trac\\xE9 89",
    d: "M259.882,242.771a1.684,1.684,0,0,1-1.742-1.615v-7.692l-9.539-8.416a.5.5,0,0,1-.054-.055,1.552,1.552,0,0,1-.363-.989.5.5,0,0,1,1,0,.537.537,0,0,0,.111.323l9.675,8.536a.5.5,0,0,1,.169.375v7.917a.689.689,0,0,0,.742.615.852.852,0,0,0,.468-.139l2.486-1.671a.583.583,0,0,0,.275-.477v-6.247a.5.5,0,0,1,.169-.375l9.678-8.535a.528.528,0,0,0,.108-.381.5.5,0,0,1,.993-.12,1.524,1.524,0,0,1-.353,1.166.5.5,0,0,1-.053.055l-9.542,8.414v6.021a1.588,1.588,0,0,1-.716,1.306L260.9,242.46a1.864,1.864,0,0,1-1.023.311Z",
    transform: "translate(-248.684 -223.887)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_90",
    "data-name": "Trac\\xE9 90",
    d: "M261.127,228.6a32.964,32.964,0,0,1-8.94-1.1c-2.619-.773-4-1.836-4-3.076,0-.873.673-1.652,2-2.315a.5.5,0,1,1,.447.9c-.933.466-1.447.97-1.447,1.42,0,.555.863,1.4,3.286,2.117a36.065,36.065,0,0,0,17.315,0c2.423-.715,3.286-1.562,3.286-2.117,0-.419-.454-.892-1.279-1.332a.5.5,0,1,1,.471-.882c1.2.641,1.808,1.385,1.808,2.214,0,1.24-1.384,2.3-4,3.076a32.964,32.964,0,0,1-8.947,1.1Z",
    transform: "translate(0 4.552)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(253.122 215.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_91",
    "data-name": "Trac\\xE9 91",
    d: "M253.78,215.648a2.871,2.871,0,1,1-2.87,2.872,2.871,2.871,0,0,1,2.87-2.872Zm0,4.743a1.871,1.871,0,1,0-1.87-1.87,1.871,1.871,0,0,0,1.87,1.87Z",
    transform: "translate(-251.41 -214.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_92",
    "data-name": "Trac\\xE9 92",
    d: "M257.52,222.446a.5.5,0,0,1-.46-.3,3.565,3.565,0,0,0-4.68-1.875,3.616,3.616,0,0,0-.679.383.5.5,0,1,1-.582-.813,4.616,4.616,0,0,1,.867-.489,4.565,4.565,0,0,1,5.993,2.4.5.5,0,0,1-.459.7Z",
    transform: "translate(-251.41 -212.701)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_93",
    "data-name": "Trac\\xE9 93",
    d: "M258.828,214.816a3.549,3.549,0,1,1-3.549,3.549A3.549,3.549,0,0,1,258.828,214.816Zm0,6.1a2.549,2.549,0,1,0-2.549-2.548,2.549,2.549,0,0,0,2.549,2.548Z",
    transform: "translate(-248.666 -215.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_94",
    "data-name": "Trac\\xE9 94",
    d: "M265.162,225.136a.5.5,0,0,1-.495-.433,4.969,4.969,0,0,0-9.849,0,.5.5,0,1,1-.991-.133,5.968,5.968,0,0,1,11.831,0,.5.5,0,0,1-.5.567Z",
    transform: "translate(-249.58 -212.44)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelIcon);
export default __webpack_public_path__ + "static/media/funnel_icon.6bf003dbe405ae0217a3dfb8d4bf13fd.svg";
export { ForwardRef as ReactComponent };